import { Suspense, lazy, memo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { FEATURE_LIST } from '../../../constants/subscription';

import { useResizeObserver } from '../../../hooks/useResizeObserver';

import { setCurrentSelectedDay } from '../../../redux/actions/calendar';

import { CALENDAR_VIEWS } from '../../../components/Calendar/constants';
import FeatureProvider from '../../../components/FeatureProvider';
import LoadingBar from '../../../components/LoadingBar';

const Calendar = lazy(() => import('../../../components/Calendar'));

function CalendarWidget() {
  const dispatch = useDispatch();

  const [calendarSizes, setCalendarSizes] = useState([]);
  const [ref, { width }] = useResizeObserver();

  useEffect(() => {
    dispatch(setCurrentSelectedDay(new Date().toISOString()));
  }, []);

  useEffect(() => {
    setCalendarSizes([width]);
  }, [width]);

  return (
    <div ref={ref}>
      <FeatureProvider name={FEATURE_LIST.CALENDAR_WIDGET}>
        <Suspense fallback={<LoadingBar />}>
          <Calendar
            calendarHeight={400}
            calendarSizes={calendarSizes}
            initialView={CALENDAR_VIEWS.MONTH}
            isToolbarVisible={false}
            slotDuration="01:00:00"
          />
        </Suspense>
      </FeatureProvider>
    </div>
  );
}

export default memo(CalendarWidget);
